import { useBooleanState } from '@calendly/hooks'
import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import { VideoIcon } from '@calendly/ui/components/icons'
import { colorTextSecondary } from '@calendly/ui/theme'

import { useFetchUsersVideoConferencingIntegrationsReport } from 'features/reporting'

import { ConnectedVideoConferencingModal } from './connected_video_conferencing_modal'
import { VIEWS } from './constants'
import { getTileTitle } from './helpers'
import { LoadingTile } from '../../components/loading_tile'
import { Tile } from '../../components/tile'


// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.connected_video_conferencing.title')
// i18n-tasks-use t('publisher.admin.dashboard.section.users.card.connected_video_conferencing.empty_state')
export const ConnectedVideoConferencingTile = () => {
  const [isModalOpen, openModal, closeModal] = useBooleanState(false)
  const { data: notConnectedUserIntegrationsData, isFetching: isNotConnectedFetching } = useFetchUsersVideoConferencingIntegrationsReport(
    { group_by: 'user', status: VIEWS.notConnected }
  )

  const { data: failedUserIntegrationsData, isFetching: isFailedFetching } = useFetchUsersVideoConferencingIntegrationsReport(
    { group_by: 'user', status: VIEWS.hasErrors }
  )

  if (isNotConnectedFetching || isFailedFetching) return <LoadingTile />

  const notConnectedCount = notConnectedUserIntegrationsData?.count || 0
  const errorCount = failedUserIntegrationsData?.count || 0

  const isEmpty = notConnectedCount === 0 && errorCount === 0
  const title = getTileTitle({ tileType: 'connected_video_conferencing', count: notConnectedCount })
  const error = errorCount > 0 && I18n.t('publisher.admin.dashboard.section.users.connection_errors', { count: errorCount })

  return (
    <>
      <Tile
        componentName="connected-video-conferencing"
        icon={<VideoIcon color={colorTextSecondary} />}
        name={title}
        error={error}
        rightControls={!isEmpty && (
          <Button onClick={openModal} decoration="outline" responsive={false} size="small">
            {I18n.t('publisher.admin.dashboard.section.users.button.view_connections')}
          </Button>
        )}
      />
      {!isEmpty && (
        <ConnectedVideoConferencingModal
          isOpen={isModalOpen}
          onClose={closeModal}
          notConnectedCount={notConnectedCount}
          errorCount={errorCount}
        />
      )}
    </>
  )
}
